export interface LineStepItem {
  title: string;
  status?: 'ACTIVE' | /* PENDING */ undefined | 'COMPLETED';
  icon: string;
  tasks: {
    selector: string;
    items: string[];
  };
}

const disconnectedSteps: LineStepItem[] = [
  {
    title: 'Request Received',
    icon: 'survey-white',
    tasks: {
      selector: 'Vendor Disconnect',
      items: ['Send disconnect request'],
    },
  },
  {
    title: 'Disconnect Order',
    icon: 'engineering-white',
    tasks: {
      selector: 'Nitel Disconnect',
      items: [
        'Disconnect service',
        'Send Disconnect Survey',
        'End billing',
        'Reclaim facilities',
      ],
    },
  },
  {
    title: 'Equipment Return',
    icon: 'mail-white',
    tasks: {
      selector: 'Equipment Return',
      items: [
        'Request equipment return',
        'Equipment return notice',
        'Confirm equipment return',
        'Invoice customer for missing equipment',
      ],
    },
  },
  {
    title: 'Complete',
    icon: 'checkmark-white',
    tasks: {
      selector: 'Equipment Return',
      items: [
        'Request equipment return',
        'Equipment return notice',
        'Confirm equipment return',
        'Invoice customer for missing equipment',
      ],
    },
  },
];

const orderSteps: LineStepItem[] = [
  {
    title: 'Preparing Order',
    icon: 'preparing-white',
    tasks: {
      selector: 'Preparing Order',
      items: ['Pricing Validation', 'Tech Spec'],
    },
  },
  {
    title: 'Survey & Delivery',
    icon: 'survey-white',
    tasks: {
      selector: 'Survey and Delivery',
      items: [
        'Submit Vendor Order',
        'Vendor FOC',
        'Site Survey',
        'Nitel FOC',
        'Carrier Firm Order Commitment Received Notice',
        'Customer Site Requirements',
        'Vendor Construction',
        'Special Construction',
        'Confirm S-Tag',
        'Populate/Confirm IP Info',
        'Ready to Configure',
        'Ready to Configure',
        'Nitel Overall Firm Order Commitment Notice',
        'Your IP Addresses Have Been Assigned Notice',
      ],
    },
  },
  {
    title: 'Service Provisioning',
    icon: 'engineering-white',
    tasks: {
      selector: 'Service Provisioning',
      items: [
        'Vendor Service Installation',
        'Assign Equipment Asset',
        'Configure Equipment',
        'Ship Equipment',
        'Equipment Shipped Notice',
      ],
    },
  },
  {
    title: 'Complete',
    icon: 'checkmark-white',
    tasks: {
      selector: 'Complete',
      items: [
        'Nitel Service Completion',
        'Start Of Service Notice',
        'Schedule Activation',
        'Activate Service',
        'Schedule Activation Notice',
        'Start Billing',
        'Service Activated Notice',
        'Send Activation Survey',
      ],
    },
  },
];

export function getSteps(orderType: string): LineStepItem[] {
  return structuredClone(
    orderType === 'Disconnect' ? disconnectedSteps : orderSteps,
  );
}
